import { Route } from '@angular/router';

export const redcamRoutes: Route[] = [
  { path: 'list', loadComponent: () => import('./pages/list/list.component').then(m => m.ListComponent) },
  { path: 'create', loadComponent: () => import('./pages/create/create.component').then(m => m.CreateComponent) },
  { path: 'edit/:id', loadComponent: () => import('./pages/create/create.component').then(m => m.CreateComponent) },
]